import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GetAllStudiesResponse } from '@app/generated-api';
import { StudyServiceV2 } from '@app/v2/services/study/study.service';
import { MedpaceTableComponent } from '@components/molecules/table/table.component';
import { MedpaceFieldMap } from '@models/medpace-field-map';
import { Observable } from 'rxjs';

@Component({
    selector: 'medpace-studies',
    imports: [CommonModule, MedpaceTableComponent],
    templateUrl: './studies.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudiesComponent {
    private readonly studyService = inject(StudyServiceV2);
    private readonly router = inject(Router);

    studyColumns: string[] = ['sponsor', 'protocol', 'ctm', 'prm', 'numSites', 'numPatients'];
    studyColumnMap: MedpaceFieldMap[] = [
        { header: 'Sponsor Name', name: 'sponsor' },
        { header: 'Protocol', name: 'protocol' },
        { header: 'CTM', name: 'ctm' },
        { header: 'PRM', name: 'prm' },
        { header: '# Sites', name: 'numSites' },
        { header: '# Patients', name: 'numPatients' },
        { header: 'Regions', name: 'regions' },
    ];

    studies$: Observable<GetAllStudiesResponse[] | null> = this.studyService.getAllStudies();

    doClickRow(event: any) {
        this.router.navigate([`studies/${event.id}`], { state: event });
    }
}
